import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  Section,
  RoadMapContainer,
  Container,
  RoadMapContent,
  RoadMapSubTitle,
  RoadMapTitle,
  GradientText,
  Line,
  BenefitsContainer,
  BenefitsWrapper,
  BenefitsContent,
  BenefitsItem,
  BenefitsItemLink,
  BenefitsItemGradient,
  BenefitsItemTitle,
  BenefitsItemSubtitle,
  BenefitsItemDescription,
  BenefitsThumbnail,
  ThumbnailMainWrapper,
  ThumbnailContentBox,
  ThumbnailFrameContainer,
  ThumbnailImageBox,
  ThumbnailMaskWrapper,
  ThumbnailImageContainer,
  ThumbnailImg,
} from "../styles/sections/RoadMapSectionStyles";

const RoadMapSection = () => {
  const [activeImage, setActiveImage] = useState(0);
  const images = [
    "https://framerusercontent.com/images/ltHquk1P350kdSYMxNWi6LlasI.gif",
    "https://framerusercontent.com/images/oirNrAtShIXEkCH5P0BGk7SeS0.webp",
    "https://framerusercontent.com/images/m5cmCHXZ5Lv0mmAceC6j5YtEQ.png",
    "https://framerusercontent.com/images/C1onPWkxuIHvzhpxe3JY9CSmu6c.webp",
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idStr = entry.target.closest('.benefits-item').id;
            console.log('Element ID:', idStr);
            const idMatch = idStr.match(/benefits-item-(\d+)/);
            if (idMatch && idMatch[1]) {
              const id = parseInt(idMatch[1]);
              console.log('Parsed ID:', id);
              setActiveImage(id);
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.8
      }
    );

    const descriptions = document.querySelectorAll(".benefits-item-description");
    console.log('Total descriptions found:', descriptions.length);
    descriptions.forEach((desc) => {
      console.log('Observing description in:', desc.closest('.benefits-item')?.id);
      observer.observe(desc);
    });

    return () => {
      descriptions.forEach((desc) => observer.unobserve(desc));
    };
  }, []);

  useEffect(() => {
    console.log('activeImage changed:', activeImage);
  }, [activeImage]);

  return (
    <Section id="roadmap">
      <RoadMapContainer>
        <Container>
          <RoadMapContent>
            <RoadMapSubTitle>What you get</RoadMapSubTitle>
            <RoadMapTitle
              as={motion.div}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <GradientText>Road Map</GradientText>
            </RoadMapTitle>
          </RoadMapContent>
        </Container>
        <Line
          as={motion.div}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />
      </RoadMapContainer>

      <BenefitsContainer id="benefits">
        <BenefitsWrapper>
          <BenefitsThumbnail>
            <ThumbnailMainWrapper>
              <ThumbnailContentBox>
                <ThumbnailFrameContainer>
                  <ThumbnailImageBox>
                    <ThumbnailMaskWrapper>
                      <ThumbnailImageContainer>
                        <ThumbnailImg
                          src={images[activeImage]}
                          alt="Roadmap Thumbnail"
                          width={1792}
                          height={1024}
                          loading="lazy"
                        />
                      </ThumbnailImageContainer>
                    </ThumbnailMaskWrapper>
                  </ThumbnailImageBox>
                </ThumbnailFrameContainer>
              </ThumbnailContentBox>
            </ThumbnailMainWrapper>
          </BenefitsThumbnail>

          <BenefitsContent>
            <BenefitsItem
              id="benefits-item-0"
              className="benefits-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <BenefitsItemLink>
                <BenefitsItemGradient />
                <BenefitsItemTitle>2025 Q1</BenefitsItemTitle>
                <BenefitsItemSubtitle>PRE-LAUNCH</BenefitsItemSubtitle>
                <BenefitsItemDescription className="benefits-item-description">
                  Titan's Tap Platform Development
                  <br />
                  Community Building and Marketing
                  <br />
                  Strategic Partnerships
                </BenefitsItemDescription>
              </BenefitsItemLink>
            </BenefitsItem>
            <BenefitsItem
              id="benefits-item-1"
              className="benefits-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <BenefitsItemLink>
                <BenefitsItemGradient />
                <BenefitsItemTitle>2025 Q2</BenefitsItemTitle>
                <BenefitsItemSubtitle>
                  TIT TOKEN & GAME OFFICIAL LAUNCH
                </BenefitsItemSubtitle>
                <BenefitsItemDescription className="benefits-item-description">
                  Official Launch of TIT Tokens for Trading and Distribution 1st
                  Exchange Listed Overseas Famous Exchange Titan's Tap V1.0
                  Telegram Official Launch and Strengthen Community
                </BenefitsItemDescription>
              </BenefitsItemLink>
            </BenefitsItem>
            <BenefitsItem
              id="benefits-item-2"
              className="benefits-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <BenefitsItemLink>
                <BenefitsItemGradient />
                <BenefitsItemTitle>2025 Q3</BenefitsItemTitle>
                <BenefitsItemSubtitle>EXPANSION</BenefitsItemSubtitle>
                <BenefitsItemDescription className="benefits-item-description">
                  Platform Feature Expansion Ver2.0 Update
                  <br />
                  Strengthening partnerships and collaborations
                  <br />
                  Integration with DeFi and NFTs
                </BenefitsItemDescription>
              </BenefitsItemLink>
            </BenefitsItem>
            <BenefitsItem
              id="benefits-item-3"
              className="benefits-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <BenefitsItemLink>
                <BenefitsItemGradient />
                <BenefitsItemTitle>2025 Q4</BenefitsItemTitle>
                <BenefitsItemSubtitle>1st AIR DROP EVENT</BenefitsItemSubtitle>
                <BenefitsItemDescription className="benefits-item-description">
                  Airdrop Event for the Titan's Tap Community
                </BenefitsItemDescription>
              </BenefitsItemLink>
            </BenefitsItem>
          </BenefitsContent>
        </BenefitsWrapper>
      </BenefitsContainer>
    </Section>
  );
};

export default RoadMapSection;
